import { useMemo } from 'react';
import { movies } from '@/mocks/movies';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import CategorySidebar from '@/pages/home/components/CategorySidebar';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import HotRecommendations from '@/pages/home/components/HotRecommendations';
import NewsSection from '@/pages/home/components/NewsSection';

export default function Home() {
  useDocumentMeta({
    title: '神马影院 - 最新电影电视剧全集资源平台',
    description: '神马影院为您提供丰富的电影、电视剧资源和影视资讯，涵盖热门影片、最新剧集，让您轻松发现和观看精彩影视内容。',
    keywords: '神马影院,电影,电视剧,影视资源,影视推荐,电影全集,电视剧全集,免费高清影视',
    path: '/',
  });

  const featured = useMemo(() => movies.filter((movie) => movie.featured), []);

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6 md:py-8">
      <div className="animate-fade-up">
        <HeroCarousel items={featured} />
      </div>

      <div className="mt-6 animate-fade-up md:mt-8">
        <CategoryEntries />
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:mt-10 lg:grid-cols-[260px_1fr] lg:gap-8">
        <CategorySidebar />
        <div className="space-y-10">
          <LatestUpdates movies={movies} />
          <HotRecommendations movies={movies} />
        </div>
      </div>

      <div className="mt-10 md:mt-12">
        <NewsSection />
      </div>
    </div>
  );
}